export default "__VITE_ASSET__492da571__"